import React, { useEffect, useCallback, useMemo } from 'react';
import { useParams, useLocation } from 'react-router-dom';

import { View } from '@gogame/components';
import { useLinkNavigate } from '@gogame/screens';

import { smartRulesLink } from 'scenes/SmartRules/navigation';
import { trackerLink } from 'scenes/Trackers/Tracker/navigation';

import { useLoadLog, useLoadDimensions } from './hooks';
import { getTrackerParams } from './utils/getTrackerParams';
import { resolveLogDimensions } from './utils/resolveLogDimensions';

const SmartRulesTrackerRedirect = () => {
  const navigateToTrackerLink = useLinkNavigate(trackerLink, {
    skipDefault: true,
  });

  const navigateToSRLink = useLinkNavigate(smartRulesLink);
  const { id } = useParams();
  const location = useLocation();
  const loadLog = useLoadLog();
  const loadDimensions = useLoadDimensions();

  const { affectedDimension, affectedSecondaryDimension } = useMemo(() => {
    return location.search
      ? Array.from(new URLSearchParams(location.search)).reduce((m, pair) => {
          const [k, v] = pair;
          return {
            ...m,
            [k]: v,
          };
        }, {})
      : {};
  }, [location.search]);

  const loadParams = useCallback(async () => {
    try {
      const [data, dimensions] = await Promise.all([
        loadLog({ id: id }),
        loadDimensions(),
      ]);

      const resolvedData = resolveLogDimensions(data, dimensions);

      const trackerParams = getTrackerParams({
        ...resolvedData,
        affectedDimension,
        affectedSecondaryDimension,
      });

      navigateToTrackerLink(trackerParams);
    } catch (e) {
      navigateToSRLink();
    }
  }, [affectedDimension, affectedSecondaryDimension]);

  useEffect(() => {
    loadParams();
  }, [loadParams]);

  return <View loading={true} />;
};

export default SmartRulesTrackerRedirect;
